<template>
  <div class="right_body" v-loading="$store.state.isLoading" :element-loading-text="$store.state.loadingTxt">
    <!-- 搜索 -->
    <search-box
    :fromData="fromData"
    :MaterialType="MaterialType"
    :MaterialGroup="MaterialGroup"
    @subSearch="subSearch"
    ></search-box>
    <!-- 操作按钮  -->
    <list-btn
    ref="actionbtn"
    :uploadUrl="uploadUrl"
    :downloadUrl="downloadUrl"
    @uploadExcel="uploadExcel"
    @uploadBtn="uploadBtn"
    :listArr="listArr"
    :sdata="sdata"
    @detail="detail"
    @edit="edit"
    @add="add"
    @del="del"
    @restore="restore"
    isAdd
    isEdit
    isDelStatus
    isExcel
    ></list-btn>
    <tab-list
    :tabList="listArr"
    :total="total" 
    :pages="pages"
    :fromData="fromData"
    :columns="tabColumns"
    tabName="base-matter"
    @currentChange="currentChange"
    @changePages="changePages"
    @selectSdata="selectSdata"
    @dbClick="dbClick">
    </tab-list>

    <!-- 物料详情 -->
    <el-dialog title="物料详情"
    :visible.sync="dialogFormVisible"
    customClass="dialog_detail_style"
    v-dialogDrag @closed="closedDialog" >
      <detail :sdata="sdata" class="contnet_box"></detail>
    </el-dialog>

  </div>
</template>

<script>
import {mapState, matActions} from 'vuex';
import {excelUpload,excelDownload} from 'api/excel.js'
import {matterApi,matterTypeApi,matterGropApi,measureUnitApi,factoryApi} from 'api/base.js';
import listBtn from 'components/btn/listBtn.vue';
import tabList  from 'components/table/list.vue';
//import tabList  from 'components/table/vxeTabList.vue';
import dialogDetail from 'components/common/detail.vue';
import searchBox from './components/list/search.vue';
import detail from './detail.vue';

export default{
  components:{searchBox,tabList,listBtn,dialogDetail,detail},
  data(){
    return{
      dialogFormVisible:false,
      loading:true,
      isComponentChild:false,
      sdata:{},//选择的物料
      listArr:[],
      downloadUrl:excelDownload.material,
      uploadUrl:excelUpload.material,
      tabColumns:[
        {field: 'materialCode', title: '物料编码', width:100,need:true,"sortable":true},
        {field: 'materialDesc', title: '物料描述',need:true,isResize:true},
        {field: 'materialTypeName', title: '物料类型'}, 
        {field: 'materialGroupDesc', title: '物料组'},
        {field: 'specifications', title: '规格'},
        {field: 'basicUnitDesc', title: '基本单位'},
        {field: 'createDate', title: '创建日期'},
        {field: 'maintainStatus', title: '状态',
        formatter: function (rowData,rowIndex,pagingIndex,field) {
          return rowData.maintainStatus === 'X' ? "已删除" : "正常";
        }}
      ],//表头字段

      MaterialType:[],//类型
      MaterialGroup:[],//物料组
      total:0,//总条数
      pages:0,//总页数
      fromData:{
      	page:1,//当前页
      	pageSize:20,//每页显示的数量,
      	searchCriteria:{//查询的附加条件
      	}
      }
    }
  },
  created(){
    this.getList();
    this.getStartData();
  },
  mounted(){
    this.isComponentChild = true;
  },
  computed:{
    //...mapState('cache',)
  },
  methods:{
    //双击
    async dbClick(data){
      console.log(data.materialId,'==  4646 ==');
      let res = await this.$get(matterApi.find,{materialId:data.materialId})
      if(res.status){
        console.log(res.data)
        this.sdata = res.data;
        this.detail();
      }else{
        this.$message.error(res.msg);
      } 
    },
    //选中数据
    selectSdata(data){
      this.sdata = data;
      console.log(this.sdata,'==  4646 ==');
    },
    //获取初始数据，只需执行一次的
    async getStartData(){
      //获取物料类型列表
      let MaterialType = await this.$post(matterTypeApi.list,this.$store.state.getAllPage);
      if(MaterialType.status) this.MaterialType = MaterialType.data.list;
      //获取物料组列表
      let MaterialGroup = await this.$post(matterGropApi.list,this.$store.state.getAllPage);
      if(MaterialGroup.status) this.MaterialGroup = MaterialGroup.data.list;
    },
    //获取初始数据
    async getList(){
      let res = await this.$post(matterApi.list,this.fromData);
      if(res.status && res.data){
        this.listArr = res.data.list;
        this.pages = res.data.pages;
        this.total = res.data.total;
      }else{
        this.listArr = [];
        this.pages = 0;
        this.total = 0;
      }
      this.loading = false;
      this.isComponentChild = true;
    },
    //当前页码改变
    currentChange(currentPage){
      this.fromData.page = currentPage;
      this.getList();
    },
    //页码条数改变
    changePages(pages){
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getList();
    },
    handleSelectChange(item,key){
      this.$set(this.listArr[key],'isChecked',!item.isChecked);
      if(item.isChecked){
        this.sdata = item;
        this.listArr.forEach((items)=>{
          if(items.materialId != item.materialId){
            this.$set(items,'isChecked',false);
          };
          if(item.maintainStatus === 'X'){
            this.sdata.isDel = true;
          }else{
            this.sdata.isDel = false;
          }
        });
      }else{
        this.sdata = {};
      }
    },
    //搜索
    subSearch(){
      this.fromData.page = 1;
      this.getList();
    },
    //新增
    add(){
      this.$router.push({'name':'base-matter-add'});
    },
    //编辑
    edit(){
      console.log(this.$route);
      //
      
      if(!this.sdata.materialId){
        this.$message.error('请选择需要编辑的记录');
        return;
      }
      //
      //this.$route.meta.isReloadTargetRoute=true;
      //this.$router.push({name: 'base-matter-edit', params:{id:this.sdata.materialId}});      
      this.$keepAliveManager.pushRouter(this,{name: 'base-matter-edit', params:{id:this.sdata.materialId}});
    }, 
    //详情
    async detail(){
      if(!this.sdata.materialId){
        this.$message.error('请选择要查看的记录');
        return;
      }
      this.dialogFormVisible = true;
    },
    //关闭弹出层
    closedDialog(){
      this.dialogFormVisible = false;
    },
    //删除
    del(){
      let vm = this;
      if(!this.sdata.materialId){
        this.$message.error('请选择需要删除的记录');
        return;
      }
      this.$confirm('确定删除这条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.changeDataStatus(matterApi.del,"删除成功！","X");
      }).catch(() => {});
    },
    //恢复删除
    restore(){
      let vm = this;
      if(!this.sdata.materialId){
        this.$message.error('请选择需要恢复的物料');
        return;
      }
      this.$confirm('恢复此记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
          this.changeDataStatus(matterApi.restore,"修改成功！","");
      });
    },
    /**
     * [ 改变物料状态 ]
     * @param {Object} api 调用的接口
     * @param {Object} message 操作成功后，提示的消息
     * @param {Object} status  操作成功后，状态
     */
    async changeDataStatus(api,message,status){
      this.$store.state.loadingTxt = "处理中...";
      this.$store.state.isLoading = true;
      let res = await this.$get(api,{materialCode:this.sdata.materialCode});
      this.$store.state.isLoading = false;
      if(res.status){
        this.$message.success("物料"+this.sdata.materialCode+message);
        this.$set(this.sdata,'maintainStatus',status);
      }else{
        this.$message.error(res.msg);
        this.sdata.isDel = false;
      }
    },
    uploadBtn(){
      this.$refs.actionbtn.uploadDialog = true;
    },
    //上传excel
    uploadExcel(res){
      if(!res.data) return;
      if(res.data){
        console.log(res.data,88888); return;
      }
      let list = res.data.rightData;
      list.forEach((item)=>{
        let resIndex = this.selectedList.findIndex(v=>v.materialCode === item.materialCode);
        if(resIndex != -1){//存在相加
          let quantity = item.quantity +this.selectedList[resIndex].quantity;
          this.$set(this.selectedList[resIndex],'quantity',quantity);
        }else{
          let objData = {
            basicUnitCode: item.basicUnitCode,
            basicUnitDesc: item.basicUnitDesc,
            basicUnitId: item.basicUnitId,
            materialCode: item.materialCode,
            materialDesc: item.materialDesc,
            materialId: item.materialId,
            standardCurrAmount: item.purchasePrice,//价格
            quantity: item.quantity,//数量
            materialGroupDesc: item.materialGroupDesc,//物料组描述
            materialGroupId:item.materialGroupId,//物料组IE
            materialTypeId: item.materialTypeId,//物料类型
            materialTypeName: item.materialTypeName,
            "factoryCode":this.fromData.factoryCode,//工厂
            "factoryDesc":this.fromData.factoryDesc,
            "factoryId":this.fromData.factoryId,
            "inventoryCode":this.fromData.inventoryCode,//库存地
            "inventoryDesc":this.fromData.inventoryDesc,
            "inventoryId":this.fromData.inventoryId,
            "supplierCode":this.noFromData.supplierCode,//供应商
            "supplierDesc":this.noFromData.supplierName,
            "supplierId":this.noFromData.supplierId,
          };
          this.selectedList.push(objData);
        }
      });

      //错误的
      let failData = res.data.failData;
      if(failData.length){
        this.isExcelError = true;
        this.excelErrorList = failData;
      }
    }
  }
}
</script>

<style>
</style>
